<template>
  <div v-if="Object.keys(plan).length">
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <div class="row">
      <div class="col-lg-12 ls-display-flex flex-wrap-wrap">
        <div class="col-md-8 col-xlg-7 col-lg-7 ls-display-flex align-itens-strech">
          <div class="ls-box ls-sm-space ls-md-margin-bottom">
            <div class="col-md-12 col-xs-12 ls-float-left ls-no-padding">
              <div class="col-md-8 col-xs-8 ls-no-padding">
                <h4 class="ls-title-3 ls-no-margin">{{ $t('plans.show.title') }}</h4>
              </div>
              <div class="ls-float-right">
                <authorized-link tag="update_plan">
                  <router-link :to="{ name: 'edit_plan', params: { id: plan.id }}" class="ls-btn-primary ls-no-margin">
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                    <span>{{ $t('application.button.edit') }}</span>
                  </router-link>
                </authorized-link>
              </div>
            </div>
            <div class="ls-clearfix"></div>
            <div class="row ls-display-flex flex-wrap-wrap">
              <label class="ls-label col-xs-6 col-lg-6 col-xlg-6">
                <b class="ls-label-text ls-text-md">{{ $t('plans.attributes.id') }}</b>
                <p class="ls-text-md">{{ plan.id }}</p>
              </label>
              <label class="ls-label col-xlg-6 col-lg-6 col-xs-6">
                <b class="ls-label-text ls-text-md">{{ $t('plans.attributes.code') }}</b>
                <p class="ls-text-md">{{ plan.code }}</p>
              </label>
              <label class="ls-label col-xs-6 col-md-6 col-lg-6 col-xlg-6">
                <b class="ls-label-text ls-text-md">{{ $t('plans.show.plan_name') }}</b>
                <p class="ls-text-md" data-test="plan.name" name="plan.name">{{ plan.name }}</p>
              </label>
              <label class="ls-label col-xlg-6 col-lg-6 col-xs-6">
                <b class="ls-label-text ls-text-md">{{ $t('plans.show.since') }}</b>
                <p class="ls-text-md">{{ date.parseDate(plan.created_at) }}</p>
              </label>
              <label class="ls-label col-md-6 col-xlg-12 col-lg-12 col-xs-12">
                <b class="ls-label-text ls-text-md">{{ $t('plans.edit.description') }}</b>
                <p class="ls-text-md" data-test="plan.description" name="plan.description">{{ plan.description }}</p>
              </label>
              <div class="col-md-12 col-xs-12 col-lg-12">
                <h4 class="ls-title-3">{{ $t('plans.edit.value_and_periodicity') }}</h4>
              </div>
              <label class="ls-label col-xs-6 col-md-6 col-lg-6 col-xlg-6">
                <b class="ls-label-text ls-text-md">{{ $t('plans.show.charge') }}</b>
                <p data-test="plan.periodicity" class="ls-text-md" v-if="periodCharge(plan.periodicity)">{{ $t('plans.show.period_charge', { period: plan.periodicity }) }}</p>
                <p data-test="plan.periodicity" class="ls-text-md" v-else>{{ normalizePeriodicity(plan.periodicity) }}</p>
              </label>
              <label class="ls-label col-xs-6 col-md-6 col-lg-6 col-xlg-6">
                <b class="ls-label-text ls-text-md">{{ $t('plans.attributes.value') }}</b>
                <p data-test="plan.price" class="ls-text-md" name="plan.price">R$ {{ money.parseViewValue(this.plan.price) }}</p>
              </label>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-xlg-5 col-lg-5 ls-display-flex align-itens-strech">
          <div class="ls-box ls-sm-space ls-md-margin-bottom">
            <h4 class="ls-title-3 ls-md-margin-bottom">{{ $t('plans.show.last_subscriptions') }}</h4>
            <table v-if="contracts.length" class="ls-table ls-txt-center ls-sm-space fixed_header">
              <thead>
                <tr>
                  <th>{{ $t('plans.show.subscription') }}</th>
                  <th>{{ $t('plans.attributes.name') }}</th>
                  <th>{{ $t('plans.attributes.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="contract in contracts">
                  <td><router-link class="link" :to="{ name: 'contract_details', params: { id: contract.id }}" title="">{{ contract.id }} <span class="ls-ico-shaft-right"></span></router-link><div>{{ date.parseDate(contract.created_at) }}</div></td>
                  <td>{{ contract.customer.name }}</td>
                  <td>{{ $t('contracts.attributes.statuses.' + contract.status) }}</td>
                </tr>
              </tbody>
            </table>
            <p v-else>{{ $t('contracts.alerts.subscription_not_found') }}</p>
            <div v-if="contracts.length" class="ls-float-right">
              <p><a href="#"  class="link" @click.prevent="redirectToContracts()" :title="$t('plans.show.view_all_subscriptions')">{{ $t('plans.show.view_all_subscriptions') }}<span class="ls-ico-shaft-right ls-xs-margin-left"></span></a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-inactive v-model="inactiveObjects"></modal-inactive>
    <modal-active v-model="activeObjects"></modal-active>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import ModalInactive from './components/ModalInactive'
  import ModalActive from './components/ModalActive'
  import money from 'src/utils/money'
  import date from 'src/utils/date'
  import filter from 'src/utils/filter'
  import scroll from 'src/utils/scroll'

  export default {
    name: 'ShowPlan',
    components: { ModalInactive, ModalActive, Breadcrumb },
    data () {
      return {
        inactiveObjects: { show: false },
        activeObjects: { show: false },
        money: money,
        date: date,
        error: false,
        crumbs: {
          'ico': 'ls-ico-docs',
          'section': this.$t('plans.show.view_registered_plan'),
          'paths': {
            0: {
              'title': this.$t('plans.main.title'),
              'path': '/plans'
            },
            1: {
              'title': this.$t('plans.show.details'),
              'path': ''
            }
          }
        }
      }
    },
    mounted () {
      this.getPlan()
    },
    computed: {
      ...mapGetters(['plan', 'contracts'])
    },
    methods: {
      ...mapActions(['loadPlan', 'loadContracts']),
      ...mapMutations(['setFilterContract', 'setPageData', 'setPagination']),
      setUpdateData () {
        if (this.plan.active) {
          this.inactiveObjects.show = true
          this.inactiveObjects.callback = scroll.scrollToFlash
        } else {
          this.activeObjects.show = true
          this.activeObjects.callback = scroll.scrollToFlash
        }
      },
      stopLoading () {
        this.$loader.hide()
      },
      normalizePeriodicity (periodicity) {
        switch (periodicity) {
          case 1:
            return 'Mensal'
          case 2:
            return 'Bimestral'
          case 3:
            return 'Trimestral'
          case 6:
            return 'Semestral'
          case 12:
            return 'Anual'
          default:
            return periodicity
        }
      },
      periodCharge (periodicity) {
        var periods = [1, 2, 3, 6, 12]
        if (periods.includes(periodicity)) {
          return false
        } else {
          return true
        }
      },
      redirectToContracts () {
        this.setFilterContract({key: 'contract[contract_plans][plan_id]', value: this.plan.id})
        this.$router.push('/contracts')
      },
      getPlan () {
        this.$loader.show()
        this.loadPlan(this.$route.params.id).then(this.getContracts)
      },
      getContracts () {
        var params = filter.toQueryWithPagination({ 'contract[contract_plans][plan_id]': this.plan.id }, { per_page: 5, current_page: 1 })
        this.loadContracts(params).then(this.afterLoad)
      },
      afterLoad () {
        this.$loader.hide()
      },
      getActiveContracts () {
        var actives = 0
        for (var contract of this.contracts) {
          if (contract.status === 'active') actives += 1
        }
        return actives
      }
    },
    beforeDestroy () {
      this.setPageData({})
      this.setPagination({})
    }
  }
</script>



// WEBPACK FOOTER //
// Show.vue?51271265